export enum DRAW_DOWN_STATES {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  FORECLOSED = 'FORECLOSED',
  OVERDUE = 'OVERDUE',
}
